package game.entity

import com.soywiz.kmem.toIntRound
import com.soywiz.korma.geom.Point
import game.Game
import game.ROOM_HEIGHT
import game.ROOM_WIDTH
import game.Room
import kotlin.random.Random

enum class GhostLevel(val sprite: String, val hp: Int, val damage: Int, val speed: Double) {
    Ghost1(
        "ghost-1",
        1,
        1,
        0.1
    ),
    Ghost2(
        "ghost-2",
        2,
        3,
        0.2
    ),
    Ghost3(
        "ghost-3",
        4,
        5,
        0.3
    )
}

class Ghost(val level: GhostLevel) : Enemy(hp = level.hp, damage = level.damage) {
    var destCol = 0
    var destRow = 0
    var vectRow = 0.0
    var vectCol = 0.0
    var realCol = 0.0
    var realRow = 0.0

    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById(level.sprite)

        chooseRandomDestination()
    }

    private fun chooseRandomDestination() {
        do {
            destCol = Random.nextInt(1, ROOM_WIDTH - 2)
            destRow = Random.nextInt(2, ROOM_HEIGHT - 2)
        } while (destCol == col && destRow == row)

        val distance = Point(col, row).distanceTo(destCol, destRow)

        vectCol = (destCol - col.toDouble()) / distance * level.speed
        vectRow = (destRow - row.toDouble()) / distance * level.speed

        realCol = col.toDouble()
        realRow = row.toDouble()
    }

    override fun onTick(game: Game, room: Room) {
        realCol += vectCol
        realRow += vectRow

        col = realCol.toIntRound()
        row = realRow.toIntRound()

        if (col == destCol && row == destRow) {
            chooseRandomDestination()
        }
    }
}